/**
 * Service / repair partner portal (merchant domain, `/service`).
 * Real since D5: every entry is a crud action on the service models
 * (lib/service/* on the server). Ids are human numbers: tickets ST-…, jobs
 * RJ-…, visits FV-…, warranties WR-…, claims WC-…, technicians by code (T1…).
 */
const crudAction = (model, action, data) => ({ url: `/api/crud/${model}`, method: 'POST', data: { action, data } });

export default {
  serviceOverview: () => crudAction('ServiceTicket', 'overview', {}),

  // Tickets (R-01, R-02)
  serviceTickets: (params = {}) => crudAction('ServiceTicket', 'queue', params),
  serviceTicket: ({ id }) => crudAction('ServiceTicket', 'manage', { id }),
  serviceTicketOpen: (body) => crudAction('ServiceTicket', 'open', body),
  serviceTicketTriage: (body) => crudAction('ServiceTicket', 'triage', body),
  serviceTicketSchedulePickup: (body) => crudAction('ServiceTicket', 'schedulePickup', body),
  // { purpose: custody (id = ticket) | return (id = job) } → texts the customer a handover code
  serviceHandoverCode: (body) => crudAction('ServiceTicket', 'sendCode', body),
  serviceTicketCustody: (body) => crudAction('ServiceTicket', 'custody', body), // { id, acceptedBy, condition, mediaId, otp, kind }
  serviceTicketCreateJob: (body) => crudAction('ServiceTicket', 'createJob', body),

  // Work orders (R-03, R-04, R-05)
  serviceJobs: (params = {}) => crudAction('ServiceJob', 'board', params),
  serviceJob: ({ id }) => crudAction('ServiceJob', 'manage', { id }),
  serviceJobMove: (body) => crudAction('ServiceJob', 'move', body),
  serviceJobAssign: (body) => crudAction('ServiceJob', 'assign', body),
  serviceJobDiagnosis: (body) => crudAction('ServiceJob', 'diagnose', body),
  serviceJobWorklog: (body) => crudAction('ServiceJob', 'worklog', body),
  serviceJobLabourNotes: (body) => crudAction('ServiceJob', 'labourNotes', body),
  serviceJobPartsUsage: (body) => crudAction('ServiceJob', 'useParts', body),
  serviceJobQc: (body) => crudAction('ServiceJob', 'qc', body),
  serviceJobComplete: (body) => crudAction('ServiceJob', 'complete', body),
  serviceJobReturnAck: (body) => crudAction('ServiceJob', 'returnAck', body), // { id, otp, condition? }

  // Quotes
  serviceEstimateCreate: (body) => crudAction('ServiceEstimate', 'draft', body),
  serviceEstimateSend: (body) => crudAction('ServiceEstimate', 'send', body),
  // A decision the customer gave at the counter or by phone (shoppers decide on the storefront).
  serviceEstimateDecision: (body) => crudAction('ServiceEstimate', 'record', body),

  // Invoice (staff record the payment: cash / UPI / card)
  serviceInvoiceCreate: (body) => crudAction('ServiceJob', 'invoice', body),
  serviceInvoiceMarkPaid: (body) => crudAction('ServiceJob', 'markPaid', body),

  // Parts and people
  serviceParts: (params = {}) => crudAction('Part', 'stock', params),
  serviceTechnicians: () => crudAction('Technician', 'roster', {}),

  // Technician field jobs (R-06); every action carries a clientDraftId (offline-safe)
  serviceFieldJobs: (params = {}) => crudAction('FieldVisit', 'visits', params),
  serviceFieldAssign: (body) => crudAction('FieldVisit', 'assign', body),
  serviceFieldCheckIn: (body) => crudAction('FieldVisit', 'checkIn', body),
  serviceFieldEvidence: (body) => crudAction('FieldVisit', 'evidence', body), // { id, mediaIds }
  serviceFieldWorklog: (body) => crudAction('FieldVisit', 'note', body),
  serviceFieldAck: (body) => crudAction('FieldVisit', 'ack', body),

  // Warranty and returns (SERV-05)
  serviceWarranty: () => crudAction('WarrantyClaim', 'desk', {}),
  serviceWarrantyCheck: (body) => crudAction('WarrantyClaim', 'check', body),
  serviceWarrantyClaim: (body) => crudAction('WarrantyClaim', 'file', body),
  serviceWarrantyReopen: (body) => crudAction('WarrantyClaim', 'reopen', body),
  serviceWarrantyEscalate: (body) => crudAction('WarrantyClaim', 'escalate', body),
};
